<template>

  <div class="lobby">

    <template v-if="!condition">
      <div class="bghome"></div>
      <FModal></FModal>
    </template>



    <template v-else>
      <!-- keep video stuff here for future -->
      <!--<video autoplay id="videofly">
        <source :src="Flythrough" type="video/mp4">
      </video>-->

      <Header id="Header"/>
      <HomeLobby id="HomeLobby"/>
    </template>


  </div>
  
</template>





<script>
import Header from "../components/Header.vue";
import FModal from "@/components/FModal";
import HomeLobby from '../components/HomeLobby.vue';

/*import Flythrough from '../assets/Flythrough.mp4';*/


export default {

  name: 'Lobby',
  components: {
    Header,
    FModal,
    HomeLobby
  },
  /*data () {
    return {
        Flythrough
    }
  },/* This too, please don't delete, thanksssss
  mounted() {

    let videofly = document.getElementById("videofly");
    let header = document.getElementById("Header");
    let homelobby = document.getElementById("HomeLobby");

    videofly.onended = function() {
      /*videofly.style.display = "none";

      var op = 1;  // initial opacity
      var timer = setInterval(function () {
          if (op <= 0.1){
            clearInterval(timer);
            videofly.style.display = 'none';
          }

          header.style.display = 'block';
          homelobby.style.display = 'block';

          videofly.style.opacity = op;
          videofly.style.filter = 'alpha(opacity=' + op * 100 + ")";
          op -= op * 0.1;
      }, 50);
    }
  },*/
  computed: {
    condition() {

      let localStore = localStorage.getItem('magicLink');
      let localStore_ticketId = localStorage.getItem('ticketId');

      if(localStore !== null && localStore_ticketId !== null )
        return true;
      else
        return false;
    }
  },
  created () {
    let userID = localStorage.getItem('user_id');

    this.$ga.set({'dimension1': userID})
    this.$ga.set({'user_id': userID})
    
    console.log("user_id"+ userID);
  }
}

</script>



<style scoped>

  .bghome {
    display: block;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url('../assets/bghome.png');
    height: 1000px;
  }

  /*#videofly {
    position: absolute;
    z-index: 9999999;

    object-fit: cover;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
  }*/

  #Header, #HomeLobby {
    /*display: none;*/
  }

</style>